export default __webpack_public_path__ + "images/33_1_image.jpg";